import Vue from 'vue';

import '../../js/management/common';
import ManagerApp from '../management/ManagerApp.vue';
Vue.component('manager-app', ManagerApp);

import 'datatables';
import 'datatables/media/css/jquery.dataTables.css';
import '../../js/ext/dataTables-ext.js';

import '../../js/project-importer.js';
import '../../js/active-data-manager.js';
import '../../js/workflows.js';
// Used in workflow components
import '../../css/lib/progress-wizard.min.css';

import '../../css/subject-management.css';

import SubTabButtons from '../components/SubTabButtons.vue';
Vue.component('sub-tab-buttons', SubTabButtons);

// Per app tab components will add onto this
window.tabComponents = {
	BulkEditProjectApps: {
		component: () => import(/* webpackChunkName: "BulkEditProjectApps" */ '../tabs/BulkEditProjectApps'),
		props: () => {
			return {
				projects: $.allLoadedSchools,
				plicApps: $.activePlicApps.map(function(app) {
					return {
						value: app.slug,
						text: app.name
					}
				}),
				currentPlicApp: process.env.VUE_APP_PLIC_APP_SLUG
			};
		},
		events: {
			back: () => {
				if(window.updateSchoolsList) {
					window.updateSchoolsList();
				}

				window.returnToMainTab();
			}
		}
	},
	CreateStudio: {
		component: () => import(/* webpackChunkName: "CreateStudio" */ '../tabs/CreateStudioForm'),
		props: () => {
			return {
				plicOrgId: $.PlicOrgId,
				masterLicense: $.plicLicense
			};
		}
	},
	ProjectWizard: {
		component: () => import(/* webpackChunkName: "ProjectWizard" */ '../tabs/project-wizard/ProjectWizard.vue')
	},
	SeasonAddProjects: {
		component: () => import(/* webpackChunkName: "SeasonAddProjects" */ '../tabs/seasons/AddProjectsToSeason.vue'),
		props: () => {
			return {
				season: $.activeSeasonRow,
				plicOrgId: $.PlicOrgId
			};
		}
	},
	StudioDictionary: {
		component: () => import(/* webpackChunkName: "StudioDictionary" */ '../project-management/DictionaryManagement'),
		props: () => {
			return {
				orgId: $.OrgId,
				dictionaryWords: $.CustomDictionary
			};
		}
	},
	WorkerLogs: () => import(/* webpackChunkName: "WorkerLogs" */ '../tabs/worker-logs/WorkerLogs')
};